export default __webpack_public_path__ + "static/media/119.2fa6f8c3.gif";